'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var getParameterByName = exports.getParameterByName = function getParameterByName(search, name) {
    var match = RegExp('[?&]' + name + '=([^&]*)').exec(search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cmp-prototype-lib/lib/linkUtil.js
// module id = 231
// module chunks = 0